import { render, staticRenderFns } from "./WorkPeriodTemplateAutocomplete.vue?vue&type=template&id=ed549748&scoped=true&"
import script from "./WorkPeriodTemplateAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WorkPeriodTemplateAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed549748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
